// ** MUI Imports
import Grid from '@mui/material/Grid'
import Select from '@mui/material/Select'
import Switch from '@mui/material/Switch'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'
import Autocomplete from '@mui/material/Autocomplete'
import Button from '@mui/material/Button'
import Plus from 'mdi-material-ui/Plus'
import Chip from '@mui/material/Chip'
import ContentSave from 'mdi-material-ui/ContentSave'
import React from 'react'
import { useMutation, useQuery } from 'react-query'
import {
  ChatClaudeDto,
  chatQwenApp,
  getHpoTerms,
  phenotypeExtract,
  searchChinahpo
} from '@/@core/services/app.service'
import { useTranslation } from 'react-i18next'
import ChinahpoSearch from '@/@core/components/chinahpo-search'
import {
  GetTermsByClinicalInfoDto,
  translate,
  translates,
  getTermByClinicalInfo,
  TranslateBulkDto,
  TranslateDto
} from '@/@core/services/app.service'
import {
  containsChinese,
  deduplicateArrays,
  getArr,
  groupObjectBySize,
  unique
} from '@/@core/utils/utils'
import { CircularProgress } from '@mui/material'

interface Props {
  clinical: {
    termList: any[]
    clinicalInformation?: string
  }
  fn?: any
}

const StepClinical = (props: Props) => {
  const { t } = useTranslation()
  const [sampleField, setSampleField] = React.useState({
    ...props
  })
  const [backop, setBackop] = React.useState(false)

  const translateValue = async (value: string[]) => {
    const sourceLanguage = 'en',
      targetLanguage = 'zh'

    const params: TranslateDto = {
      sourceLanguage,
      targetLanguage,
      sourceText: value.join('，')
    }

    const data = await Translate.mutateAsync(params)

    const flag = true

    if (flag) {
      // const data1 = await getHpoTermsMutation.mutateAsync(data)
      const data2 = await getPhenotypeExtractMutation.mutateAsync({
        text: data,
        lang: 'zh',
        format: 'legacy'
      })

      const parseData = data2.hpo ?? []
      if (parseData && Array.isArray(parseData)) {
        const newData = unique(parseData, 'name_en').map((i) => {
          return {
            ...i,
            title: `${i.hpo_code}${i.name_en}(${i.name_cn})`,
            keyId: `${i.hpo_code}${i.name_en.toLocaleLowerCase()}`
          }
        })

        //
        const termLists = deduplicateArrays(unique([...newData], 'keyId'), [])
          .filter((item: any) => item.name_en)
          .map((items: any) => {
            return {
              definition_cn: '',
              definition_en: '',
              hpo_code: items.hpo_code ?? '',
              name_cn: items.name_cn ?? '',
              name_en: items.name_en ?? '',
              alt_title: '',
              cn_title: '',
              incTitle: '',
              omim_code: 0,
              pre_title: items.name_en ?? '',
              prefix: '',
              title: `${items.hpo_code}${items.name_en}(${items.name_cn})`
            }
          })

        props.fn('clinical', {
          ...sampleField.clinical,
          termList: termLists
        })

        setSampleField({
          clinical: {
            ...sampleField.clinical,
            termList: termLists
          }
        })
      }
      return
    }
    return []
  }

  const getHpoAndTerms = async () => {
    setBackop(true)
    const clinicalInformation = sampleField.clinical.clinicalInformation ?? ''

    //如果包含中文，中译英
    if (!containsChinese(clinicalInformation)) {
      //
      await translateValue(
        clinicalInformation.split(',').join('，').split('，')
      )
    } else {
      //
      const flag = true

      if (flag) {
        // const data1 = await getHpoTermsMutation.mutateAsync(clinicalInformation)
        const data2 = await getPhenotypeExtractMutation.mutateAsync({
          text: clinicalInformation,
          lang: 'zh',
          format: 'legacy'
        })

        const parseData = data2.hpo ?? []
        if (parseData && Array.isArray(parseData)) {
          const newData = unique(parseData, 'name_en').map((i) => {
            return {
              ...i,
              title: `${i.hpo_code}${i.name_en}(${i.name_cn})`,
              keyId: `${i.hpo_code}${i.name_en.toLocaleLowerCase()}`
            }
          })

          //
          const termLists = deduplicateArrays(unique([...newData], 'keyId'), [])
            .filter((item: any) => item.name_en)
            .map((items: any) => {
              return {
                definition_cn: '',
                definition_en: '',
                hpo_code: items.hpo_code ?? '',
                name_cn: items.name_cn ?? '',
                name_en: items.name_en ?? '',
                alt_title: '',
                cn_title: '',
                incTitle: '',
                omim_code: 0,
                pre_title: items.name_en ?? '',
                prefix: '',
                title: `${items.hpo_code}${items.name_en}(${items.name_cn})`
              }
            })

          props.fn('clinical', {
            ...sampleField.clinical,
            termList: termLists
          })

          setSampleField({
            clinical: {
              ...sampleField.clinical,
              termList: termLists
            }
          })
        }
        return
      }
      return []
    }

    setBackop(false)
  }

  const Translate = useMutation({
    mutationFn: async (data: TranslateDto) => await translate(data),
    onSuccess: (data, variables, context) => {
      //post返回的结果
    }
  })

  const Translates = useMutation({
    mutationFn: async (data: TranslateBulkDto) => await translates(data),
    onSuccess: (
      data: { translated: string; wordCount: string; index: string }[],
      params
    ) => {
      //post返回的结果
      // if (params.sourceLanguage === 'zh')
      //   GetTermByClinicalInfo.mutateAsync({
      //     clinicalInfo: data
      //       .map(
      //         (str) =>
      //           str.translated.charAt(0).toUpperCase() + str.translated.slice(1)
      //       )
      //       .join(',')
      //   })
    }
  })

  const getChatQwenApp = useMutation({
    mutationFn: async (data: ChatClaudeDto) => await chatQwenApp(data),
    onSuccess: (data: string) => {
      //post返回的结果
      // refetch()
    },
    onError: () => {
      setBackop(false)
    }
  })

  const getHpoTermsMutation = useMutation({
    mutationFn: async (data: string) => await getHpoTerms(data),
    onSuccess: (data: { matches: any[] }) => {
      //post返回的结果
      // refetch()
      setBackop(false)
    },
    onError: () => {
      setBackop(false)
    }
  })

  const getPhenotypeExtractMutation = useMutation({
    mutationFn: async (data: { text: string; lang: string; format: string }) =>
      await phenotypeExtract(data),
    onSuccess: (data: { hpo: any[] }) => {
      //post返回的结果
      // refetch()
      setBackop(false)
    },
    onError: () => {
      setBackop(false)
    }
  })

  const GetTermByClinicalInfo = useMutation({
    mutationFn: async (data: GetTermsByClinicalInfoDto) =>
      await getTermByClinicalInfo(data),
    onSuccess: async (data: { terms: string[] }) => {
      //post返回的结果
      // const sourceLanguage = 'en',
      //   targetLanguage = 'zh'
      // const terms = await Promise.all(
      //   data.terms.map(async (item) => {
      //     const params: TranslateDto = {
      //       sourceText: item,
      //       sourceLanguage,
      //       targetLanguage
      //     }
      //     const data = await Translate.mutateAsync(params)
      //     return {
      //       definition_cn: '',
      //       definition_en: '',
      //       hpo_code: '',
      //       name_cn: data,
      //       name_en: item,
      //       alt_title: '',
      //       cn_title: '',
      //       incTitle: '',
      //       omim_code: 0,
      //       pre_title: data,
      //       prefix: '',
      //       title: `${item}(${data})`
      //     }
      //   })
      // )
      // props.fn('clinical', {
      //   ...sampleField.clinical,
      //   termList: unique(
      //     [...sampleField.clinical.termList, ...terms],
      //     'name_en'
      //   )
      // })
      // setSampleField({
      //   clinical: {
      //     ...sampleField.clinical,
      //     termList: unique(
      //       [...sampleField.clinical.termList, ...terms],
      //       'name_en'
      //     )
      //   }
      // })
    }
  })

  React.useEffect(() => {
    if (
      props.clinical &&
      props.clinical.termList &&
      props.clinical.clinicalInformation
    ) {
      setSampleField({
        ...props
      })
    }
  }, [props])

  return (
    <Grid container pt={4}>
      <Grid container>
        <Grid item xs={12} padding={'5px 0'}>
          <Grid
            container
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 1
            }}
            padding={'5px 0'}
          >
            <Grid item>
              <Button
                size="small"
                variant="contained"
                onClick={async () => {
                  await getHpoAndTerms()
                }}
                startIcon={backop ? <CircularProgress size="30px" /> : <Plus />}
                disabled={backop}
              >
                {t('apply')}
              </Button>
            </Grid>
          </Grid>

          <TextField
            label={t('Clinical information')}
            fullWidth
            id="outlined-multiline-flexible"
            multiline
            maxRows={10}
            minRows={4}
            value={sampleField.clinical.clinicalInformation}
            onChange={(e) => {
              setSampleField({
                clinical: {
                  ...sampleField.clinical,
                  clinicalInformation: e.target.value
                }
              })

              props.fn('clinical', {
                ...sampleField.clinical,
                clinicalInformation: e.target.value
              })
            }}
            placeholder={t(
              'Please enter Patient information and click the Apply button in the top corner'
            )}
          />
        </Grid>

        <Grid item xs={12} paddingBottom={'20px'}>
          <ChinahpoSearch
            termList={sampleField.clinical.termList}
            fn={(query: any) => {
              props.fn('clinical', {
                ...sampleField.clinical,
                termList: query
              })

              setSampleField({
                clinical: {
                  ...sampleField.clinical,
                  termList: query
                }
              })

              return query
            }}
            sx={{
              width: '100%',
              minWidth: 800,
              '& .MuiInputBase-root': {
                alignItems: 'flex-start'
              }
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default StepClinical
